/* eslint-disable react/display-name */
import React from 'react';
import { Spinner, SpinnerSize, Stack, StackItem } from '@fluentui/react';
import ElevatedCard from '../../components/ui/ElevatedCard';

export default function () {
  return (
    <div className="authenticate__card-container authenticate__card-container--loading">
      <ElevatedCard>
        <Stack tokens={{ childrenGap: 16 }}>
          <StackItem>
            <div className="authenticate__spinner">
              <Spinner size={SpinnerSize.large} label="Loading..." />
            </div>
          </StackItem>
        </Stack>
      </ElevatedCard>
    </div>
  );
}
